import { useTranslation } from "@refinedev/core";
import { CollapsibleSection } from "components/collapsibleSection";
import { IEventDetail, IEventSection, SupportedLanguage } from "interfaces";
import { get } from "lodash";
import { useState } from "react";

export const EventSection = ({
  eventDetailData,
}: {
  eventDetailData?: IEventDetail;
}) => {
  const defaultLanguage = (eventDetailData?.languages ?? []).includes(
    SupportedLanguage.EN
  )
    ? SupportedLanguage.EN
    : (eventDetailData?.languages ?? [])[0] ?? "";
  const [selectedContentLanguage, setSelectedContentLanguage] =
    useState(defaultLanguage);
  const { translate } = useTranslation();

  return (
    <div className="box-container p-4 sm:p-6">
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-row items-center gap-x-4">
          {translate("eventSetup.eventInfo.eventSection.viewContentByLanguage")}
          <div className="flex flex-row gap-x-1.5 p-1.5 w-fit rounded-full outline outline-solid outline-[1px] outline-brand-500">
            {(eventDetailData?.languages ?? []).map((lang, index) => (
              <img
                key={lang}
                src={`/images/flags/circle-${lang}.png`}
                alt="Language Icon"
                className={`w-4 shrink-0 cursor-pointer ${
                  lang !== selectedContentLanguage ? "opacity-20" : ""
                }`}
                onClick={() => setSelectedContentLanguage(lang)}
              />
            ))}
          </div>
        </div>
        {(eventDetailData?.details ?? []).map(
          (detail: IEventSection, index: number) => (
            <div className="border border-gray-300 rounded-lg" key={index}>
              <CollapsibleSection
                label={get(detail, `title.${selectedContentLanguage}`, "")}
                className="shadow-none"
                defaultOpen={false}
                key={index}
              >
                <div
                  className="px-4 py-4 reset-tw sm:px-6"
                  dangerouslySetInnerHTML={{
                    __html: `${get(
                      detail,
                      `description.${selectedContentLanguage}`,
                      ""
                    )}`,
                  }}
                ></div>
              </CollapsibleSection>
            </div>
          )
        )}
      </div>
    </div>
  );
};
